<div class="badge" [ngClass]="type">
    <ng-content></ng-content>
</div>